import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { ReduxState } from "../../../../../redux";
import { setDownloadOptionsSelectedDocumentIds } from "../../../../../redux/reducers/TransactionManager";
import { CheckboxOption } from "./utils";
import { getDocumentName } from "src/views/Pages/Analyze/AnalyzeTransactionsTable/utils";

export const DocumentsDropdown: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { selectedDocumentId } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );
  const { downloadOptions } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );
  const { selectedDocumentIds } = downloadOptions;

  const { data: jobDocs } = useSelector(
    (state: ReduxState) => state.JobDocument
  );

  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const newDocumentsParam = queryParams.get("newDocuments");
  const l1 = queryParams.get("l1");
  const l2 = queryParams.get("l2");

  const uniqueDocumentIds = Array.from(
    new Set((jobDocs || []).map((item) => item.documentId))
  );

  const options = uniqueDocumentIds.map((docId) => ({
    value: docId,
    label: getDocumentName(jobDocs || [], docId),
  }));

  // Set default selection based on URL parameters
  useEffect(() => {
    if ((jobDocs || []).length > 0) {
      if (newDocumentsParam) {
        // If newDocuments param exists, always select those documents (default behavior)
        const newDocs = newDocumentsParam.split(",");
        dispatch(setDownloadOptionsSelectedDocumentIds(newDocs));
      } /*if (selectedDocumentIds.length === 0)*/ else {
        // If no newDocuments param and no documents are selected, select all documents
        dispatch(setDownloadOptionsSelectedDocumentIds(uniqueDocumentIds));
      }
    }
  }, [newDocumentsParam, jobDocs?.length]);

  const selectedOptions = options.filter((option) =>
    selectedDocumentIds.includes(option.value)
  );

  const handleSelectAll = () => {
    // Select all documents without any filtering
    dispatch(setDownloadOptionsSelectedDocumentIds(uniqueDocumentIds));
  };

  const handleSelectLatest = () => {
    if (newDocumentsParam) {
      // Select documents from the newDocuments query parameter
      const newDocs = newDocumentsParam.split(",");
      dispatch(setDownloadOptionsSelectedDocumentIds(newDocs));
    }
  };

  return (
    <div>
      <div className="mb-2 d-flex align-items-center">
        <div className="small text-muted mr-2">Select:</div>
        <div>
          {l1 && l2 && (
            <>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleSelectAll();
                }}
                className="text-primary mr-3"
              >
                All docs in project
              </a>
            </>
          )}
          {newDocumentsParam && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleSelectLatest();
              }}
              className="text-primary"
            >
              Latest docs
            </a>
          )}
        </div>
      </div>
      <div>
        <Select
          options={options}
          value={selectedOptions}
          onChange={(value) => {
            dispatch(
              setDownloadOptionsSelectedDocumentIds(
                ((value || []) as any).map((x) => x.value)
              )
            );
          }}
          isMulti={true}
          closeMenuOnSelect={false}
          placeholder="Select documents to download..."
          className="basic-multi-select"
          classNamePrefix="select"
          components={{
            Option: CheckboxOption,
          }}
        />
      </div>
    </div>
  );
};
export default DocumentsDropdown;
